export const LICHESS_API_URL = 'https://lichess.org/api/'

export const deviceName = 'Launchpad X MIDI 2'
